import React from "react";
import { useDispatch, useSelector } from "react-redux";

import OutlinerItem from "./../../Outliner/OutlinerItem";
import { Typography } from "@material-ui/core";
import Toolbox from "./../../Toolbox/Toolbox";
import ToolboxItem from "./../../Toolbox/ToolboxItem";
import DeleteIcon from "@material-ui/icons/Delete";
import SliderProperty from "./../../Outliner/SliderProperty";

export default function CharacterProperties(props) {
  const { id } = props;
  const fdl = useSelector(state => state.fdl.present);
  const dispatch = useDispatch();

  const properties = fdl.props[id];

  return (
    <>
      <OutlinerItem selectable={false}>
        <Typography className="outliner-header" noWrap>
          Properties: <span className="highlight">{properties.name}</span>
        </Typography>
      </OutlinerItem>
      <SliderProperty
        min={0}
        max={100}
        step={0.1}
        marks={[
          { value: 0, label: "back" },
          { value: 100, label: "front" }
        ]}
        title="Depth"
        value={properties.depth || 10}
        defaultValue={10}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              depth: value
            }
          });
        }}
      />
      <SliderProperty
        min={-1}
        max={1}
        step={0.01}
        marks={[{ value: 0 }]}
        title="Saturation"
        value={properties.saturation}
        defaultValue={0}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              saturation: value
            }
          });
        }}
      />
      <SliderProperty
        min={-1}
        max={1}
        step={0.01}
        marks={[{ value: 0 }]}
        title="Brightness"
        value={properties.brightness}
        defaultValue={0}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              brightness: value
            }
          });
        }}
      />
      <SliderProperty
        min={0.01}
        max={2} // real max is 2.2, but we shorten the range so our default value is the linear mid-point
        step={0.01}
        marks={[{ value: 1 }]}
        title="Red (gamma)"
        value={properties.gammaR}
        defaultValue={1}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              gammaR: value
            }
          });
        }}
      />
      <SliderProperty
        min={0.01}
        max={2} // real max is 2.2, but we shorten the range so our default value is the linear mid-point
        step={0.01}
        marks={[{ value: 1 }]}
        title="Green (gamma)"
        value={properties.gammaG}
        defaultValue={1}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              gammaG: value
            }
          });
        }}
      />
      <SliderProperty
        min={0.01}
        max={2} // real max is 2.2, but we shorten the range so our default value is the linear mid-point
        step={0.01}
        marks={[{ value: 1 }]}
        title="Blue (gamma)"
        value={properties.gammaB}
        defaultValue={1}
        saveValue={value => {
          dispatch({
            type: "UPDATE_PROP",
            propId: id,
            updates: {
              gammaB: value
            }
          });
        }}
      />
      <Toolbox>
        <ToolboxItem tooltip="Delete this instance of this prop">
          <DeleteIcon
            onClick={() =>
              dispatch({
                type: "DELETE_PROP",
                propId: id
              })
            }
          />
        </ToolboxItem>
      </Toolbox>
    </>
  );
}
